<template>
  <section
    class="notification"
    :class="type ? 'notification--' + type : ''"
  >
    <h2
      v-if="title"
      class="notification__title"
    >
      {{ title }}
    </h2>
    <p class="notification__description">
      {{ description }}
    </p>
  </section>
</template>

<script>
export default {
  name: 'CNotification',

  props: {
    title: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: undefined,
      validator (value) {
        return [
          'info',
          'success',
          'warning',
          'error'
        ].indexOf(value) >= 0
      }
    }
  }
}
</script>
